import { React, useState } from 'react';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import DeleteSweepRoundedIcon from '@mui/icons-material/DeleteSweepRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import { fetchFlask } from '../../utils/fetchFlask';
import '../css/proofRequest.css';

const SolicitarComprovante = () => {
    const [notaFiscal, setNotaFiscal] = useState('');
    const [deletar, setDeletar] = useState(false);
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitSolicitarComprovante (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({
            nota_fiscal: notaFiscal,
            deletar
        });

        const response = await fetchFlask('solicitarComprovante', body);
        setMessage(response.message);
        setStatus(response.status);
        setOpenAlerta(true);
        if (response.status === 'success') {
            setNotaFiscal('');
            setDeletar(false);
        }
        setIsSubmit(false);
    };

    const completedFields = [notaFiscal].filter(Boolean).length;

    return (
        <Box className='mainBox proof-request-page'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Solicitar Comprovante
            </PageHeader>

            <form action='' method='POST' id='formSolicitarComprovante' onSubmit={submitSolicitarComprovante} className='proof-request-layout'>
                <Box className='proof-request-workspace'>
                    <Box className='proof-request-intro'>
                        <Box>
                            <h2>Solicitação de comprovante ao cliente</h2>
                        </Box>
                        <p>
                            Informe a nota fiscal para enviar uma mensagem pelo WhatsApp solicitando o comprovante de pagamento da conta.
                        </p>
                    </Box>

                    <Box className='proof-request-panel'>
                        <Box className='proof-request-section-heading'>
                            <ReceiptLongRoundedIcon />
                            <Box>
                                <span>Etapa única</span>
                                <strong>Dados da cobrança</strong>
                            </Box>
                        </Box>

                        <Box className='proof-request-input-strip'>
                            <TextField
                                required
                                label='Nota fiscal'
                                value={notaFiscal}
                                onChange={(e) => setNotaFiscal(e.target.value)}
                            />
                        </Box>
                    </Box>

                    <Box className='proof-request-erp-card'>
                        <FormControlLabel
                            className='proof-request-checkbox-control'
                            control={
                                <Checkbox
                                    checked={deletar}
                                    onChange={(e) => setDeletar(e.target.checked)}
                                />
                            }
                            label={
                                <Box className='proof-request-checkbox-copy'>
                                    <strong>Excluir conta a pagar do ERP</strong>
                                    <span>Marque somente quando a cobrança não deve permanecer aberta no Omie após a solicitação.</span>
                                </Box>
                            }
                        />
                    </Box>

                    <Box className='proof-request-channel'>
                        <WhatsAppIcon />
                        <Box>
                            <strong>Envio por WhatsApp</strong>
                            <span>A operação prepara a solicitação para o cliente enviar o comprovante de pagamento da nota fiscal informada.</span>
                        </Box>
                    </Box>
                </Box>

                <Box className='proof-request-summary'>
                    <Box className='proof-request-summary-header'>
                        <FactCheckRoundedIcon />
                        <Box>
                            <span>Resumo</span>
                            <strong>Revisão do envio</strong>
                        </Box>
                    </Box>

                    <Box className='proof-request-summary-list'>
                        <Box>
                            <span>Nota fiscal</span>
                            <strong className={!notaFiscal ? 'is-empty' : undefined}>{notaFiscal || 'Não informada'}</strong>
                        </Box>
                        <Box>
                            <span>Canal</span>
                            <strong>WhatsApp</strong>
                        </Box>
                        <Box>
                            <span>Conta a pagar</span>
                            <strong>{deletar ? 'Excluir do ERP' : 'Manter no ERP'}</strong>
                        </Box>
                    </Box>

                    <Box className='proof-request-attention'>
                        <DeleteSweepRoundedIcon />
                        <p>
                            A exclusão no ERP é opcional. Confirme a marcação antes de disparar a solicitação ao cliente.
                        </p>
                    </Box>

                    <Box className='proof-request-completion'>
                        <AssignmentTurnedInRoundedIcon />
                        <Box>
                            <span>Campos críticos</span>
                            <strong>{completedFields}/1 preenchido</strong>
                        </Box>
                    </Box>

                    <SubmitButton isSubmit={isSubmit} startIcon={<SendRoundedIcon />}>
                        Solicitar via WhatsApp
                    </SubmitButton>
                </Box>
            </form>
        </Box>
    );
};

export default SolicitarComprovante;
